/**
 * Strip XML/HTML-like tags from text (JATS, HTML, MathML).
 *
 * Backend journal abstracts sometimes carry raw JATS XML fragments like
 * <jats:p>…</jats:p>, <jats:italic>…</jats:italic>, or HTML fallbacks
 * like <p>, <i>, <em>, <sub>, <sup>. React renders these as literal text
 * (HTML-escaped), so the angle-bracket markup is visible to the user.
 *
 * Task #2731 / BUG-NEW-Z fix: strip tag markup before render. We do NOT
 * parse the content as HTML (dangerouslySetInnerHTML would open XSS via
 * untrusted corpus data) — we just drop the tag syntax so the underlying
 * prose reads cleanly.
 */
export function stripJatsXml(input: string | undefined | null): string {
  if (!input) return ''
  return (
    input
      // Strip JATS / HTML open + close tags and self-closers. Tags are
      // removed in place — chemistry abstracts like CO<jats:sub>2</jats:sub>
      // correctly collapse to CO2 rather than "CO 2".
      // Matches <ns:name ...>, </ns:name>, <name .../>
      .replace(/<\/?[A-Za-z][A-Za-z0-9_:.-]*(?:\s[^<>]*?)?\/?>/g, '')
      // Collapse runs of whitespace introduced by tag removal.
      .replace(/\s{2,}/g, ' ')
      .trim()
  )
}
